import {DiseaseTreeItemType} from "@/entities/diseaseParameters/DiseaseTreeItemType";
import {DiseaseTreeBranchModel} from "@/entities/diseaseParameters/DiseaseTreeBranchModel";
import {DiseaseTreeLeafModel} from "@/entities/diseaseParameters/DiseaseTreeLeafModel";

export class DiseaseTreeItem {
    id: number;
    parentId: number;
    branchId: number | null;
    depth: number;
    type: DiseaseTreeItemType;
    parameterText: string;
    nextParameterTitle: string;
    nextParameterItems: DiseaseTreeItem[];
    isPremium?: boolean;
    isViewable?:boolean;
    departmentType?: string;  // ✅ ADD THIS PROPERTY
    iconPath: string | undefined;
    
    constructor(
        id: number, 
        parentId: number, 
        branchId: number | null, 
        depth: number, 
        type: DiseaseTreeItemType, 
        parameterText: string, 
        nextParameterTitle: string, 
        nextParameterItems: DiseaseTreeItem[],
        departmentType?: string,
        isPremium?: boolean,
        isViewable?:boolean,
        iconPath?:string,
       
    ) {
        this.id = id;
        this.parentId = parentId;
        this.branchId = branchId;
        this.depth = depth;
        this.type = type;
        this.parameterText = parameterText;
        this.nextParameterTitle = nextParameterTitle;
        this.nextParameterItems = nextParameterItems;
        this.departmentType = departmentType;  
        this.isPremium = isPremium;
        this.isViewable = isViewable;
        this.iconPath = iconPath;
    }

    static createFromObject(parentId: number, depth: number, obj: any): DiseaseTreeItem {
        const subItems: DiseaseTreeItem[] = [];
        if (obj.nextParameterItems) {
            for (let i = 0; i < obj.nextParameterItems.length; i++) {
                const subItem = DiseaseTreeItem.createFromObject(obj.id, depth + 1, obj.nextParameterItems[i]);
                subItems.push(subItem);
            }
        }

      

        return new DiseaseTreeItem(
            obj.id, 
            parentId, 
            obj.branchId, 
            depth, 
            obj.type, 
            obj.parameterText, 
            obj.nextParameterTitle, 
            subItems,
            obj.departmentType,  // ✅ ADD THIS PARAMETER
            obj.isPremium,
            obj.isViewable,
            obj.iconPath,
        );
    }

    toDiseaseTreeItemModel(): DiseaseTreeBranchModel | DiseaseTreeLeafModel {
        if (this.nextParameterItems && this.nextParameterItems.length > 0) {
            const subItems: (DiseaseTreeBranchModel | DiseaseTreeLeafModel)[] = [];
            for (let i = 0; i < this.nextParameterItems.length; i++) {
                const subItem = this.nextParameterItems[i].toDiseaseTreeItemModel();
                subItems.push(subItem);
            }

            return new DiseaseTreeBranchModel(this.id, this.parameterText, subItems);
        }

        return new DiseaseTreeLeafModel(this.branchId as number, this.parameterText);
    }
}